import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./pantallas-senalización.css";
import signage1 from "./img-domotic/pantallaseducativas_señalizaciondigital.png"
import signage2 from "./img-domotic/pantallaseducativas_señalizaciondigital2.png"
import signage3 from "./img-domotic/pantallaseducativas_señalizaciondigital2.png"

import samsung from "./img-domotic/pantallaseducativas_señalizaciondigital.png"
import lg from "./img-domotic/pantallaseducativas_señalizaciondigital.png"
import nec from "./img-domotic/pantallaseducativas_señalizaciondigital.png"
import brightsign from "./img-domotic/pantallaseducativas_señalizaciondigital.png"

const DigitalSignage = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Señalización Digital
  const imagenesGaleria = [
    { src: signage1, alt: "Aula con pantallas interactivas", caption: "Soluciones educativas interactivas" },
    { src: signage2, alt: "Señalización digital corporativa", caption: "Gestión centralizada de contenidos" },
  ];

  const servicios = [
    {
      icon: "🏫",
      titulo: "Aulas Digitales",
      descripcion: "Pantallas interactivas para educación con software especializado.",
      features: ["Touch 4K", "Anotación en tiempo real", "Integración con LMS"]
    },
    {
      icon: "🏢",
      titulo: "Señalización Corporativa",
      descripcion: "Sistemas de comunicación visual para empresas e instituciones.",
      features: ["Gestión remota", "Programación de contenidos", "Integración de datos"]
    },
    {
      icon: "🛒",
      titulo: "Digital Signage Retail",
      descripcion: "Soluciones para puntos de venta con analítica de audiencia.",
      features: ["Pantallas 4K", "Sensores de presencia", "Contenido dinámico"]
    },
    {
      icon: "✋",
      titulo: "Quioscos Interactivos",
      descripcion: "Sistemas táctiles para autoservicio y atención al cliente.",
      features: ["Pantallas resistentes", "Software personalizado", "Integración con pagos"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Educación",
      items: [
        "Pantallas interactivas",
        "Pizarras digitales",
        "Sistemas de videoconferencia",
        "Laboratorios virtuales"
      ]
    },
    {
      categoria: "Corporativo",
      items: [
        "Salas de reuniones",
        "Wayfinding digital",
        "Pantallas de información",
        "Tableros de datos"
      ]
    },
    {
      categoria: "Retail",
      items: [
        "Videowalls",
        "Menu boards digitales",
        "Pantallas promocionales",
        "Quioscos de producto"
      ]
    }
  ];

  const marcas = [
    { nombre: "Samsung", logo: samsung },
    { nombre: "LG", logo: lg },
    { nombre: "NEC", logo: nec },
    { nombre: "BrightSign", logo: brightsign },
    { nombre: "ViewSonic", logo: "/marcas/viewsonic.png" },
    { nombre: "Planar", logo: "/marcas/planar.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.signage-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="signage-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="signage-hero">
        <div className="signage-hero-content">
          <h1 className="signage-hero-title">Pantallas Educativas y Señalización Digital</h1>
          <p className="signage-hero-subtitle">
            Soluciones interactivas para comunicación y educación
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="signage-gallery signage-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="signage-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="signage-gallery-img"
            />
            <div className="signage-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

        {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Pantallas Interactivas</h2>
    <p className="ryn-features-subtitle">Soluciones para instituciones, empresas y más</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">PANTALLAS INTERACTIVAS y SISTEMAS DE SEÑALIZACIÓN DIGITAL DE PARED </h3>
          <ul className="ryn-feature-list">
            <li>Pantallas  interactivas: sistema todo en uno,  sistemas centralizados de gestión y contenido/accesorios: OPS, micrófonos y parlantes</li>
            <li>Pantallas Gigantes para interiores y exteriores con formas personalizadas</li>
            <li>Gestión  centralizada de la señal  o cartelería digital</li>
          </ul>
        </div>
      </div>
      

    </div>
  </div>
</section>  




     


    </div>
  );
};

export default DigitalSignage;